import { Link } from 'react-router-dom'

interface Crumb {
  name: string
  path: string
}

function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-6 flex flex-wrap items-center gap-1.5 text-xs text-slate-500">
      {items.map((item, index) => (
        <span key={item.path} className="flex items-center gap-1.5">
          {index > 0 ? <span className="text-slate-700">/</span> : null}
          {index === items.length - 1
            ? <span className="text-slate-300">{item.name}</span>
            : <Link to={item.path} className="hover:text-emerald-400">{item.name}</Link>}
        </span>
      ))}
    </nav>
  )
}

export default Breadcrumbs
